<div class="row mt-4">
  <div class="col-12">
    <h5 class="mb-0 mt-0" translate>SAFEGUARD_RUN_HISTORY</h5>
    <span class="font-italic small mb-2 d-inline-block" translate>SAFEGUARD_RUN_HISTORY_DESCRIPTION</span>
  </div>
</div>

@if (loaded) {
  @if (history.length === 0) {
    <div class="mt-2 text-muted">
      {{ 'NO_RUN_HISTORY' | translate }}
    </div>
  } @else {
    <div class="table-responsive mt-2">
      <table class="table table-striped">
        <thead>
          <tr>
            <th translate>TIMESTAMP</th>
            <th class="text-end" translate>PAYMENT_COUNT</th>
            <th class="text-end" translate>TOTAL_AMOUNT</th>
            <th translate>STATUS</th>
            <th style="width: 50px;"></th>
          </tr>
        </thead>
        <tbody>
          @for (run of history; track run.id) {
            <tr>
              <td>{{ run.runTimestamp | date:'medium' }}</td>
              <td class="text-end">{{ run.paymentCount }}</td>
              <td class="text-end">{{ run.totalAmount | number:'1.2-2' }}</td>
              <td>
                <span [class]="getStatusClass(run)" class="fw-bold">
                  {{ getStatusLabel(run) | translate }}
                </span>
                @if (run.overrideUsed && run.overrideBy) {
                  <br>
                  <small class="text-muted">{{ run.overrideBy }}</small>
                }
              </td>
              <td>
                @if (run.violations.length > 0) {
                  <button class="btn btn-sm btn-link p-0" (click)="toggleExpand(run.id)">
                    <i class="fas" [ngClass]="expandedRows.has(run.id) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </button>
                }
              </td>
            </tr>
            @if (expandedRows.has(run.id)) {
              <tr>
                <td colspan="5" class="p-0 border-0">
                  <div class="px-3 py-2 bg-light">
                    @for (violation of run.violations; track violation.type) {
                      <div class="py-1">
                        <strong>{{ violation.type }}</strong>: {{ violation.message }}
                        <span class="text-muted ms-1">({{ violation.currentValue }} / {{ violation.threshold }})</span>
                      </div>
                    }
                    @if (run.overrideUsed && run.overrideReason) {
                      <div class="pt-1 border-top mt-1">
                        <strong translate>OVERRIDE_REASON</strong>: {{ run.overrideReason }}
                      </div>
                    }
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
} @else {
  <div class="d-flex justify-content-center p-3">
    <i class="fas fa-spinner fa-spin fa-2x"></i>
  </div>
}
